<h4>Add {{ title }}</h4>
<form
	#addForm="ngForm"
	(ngSubmit)="add(addForm)"
	class="flex flex-col mt-5 items-end"
>
	<app-container type="dark" class="mb-4 flex-1 w-full">
		<app-input
			label="Description"
			[(ngModel)]="description"
			[submitted]="submitted"
			[required]="true"
			name="description"
			class="flex-1 w-full"
		></app-input>
		<app-input
			label="Price"
			type="cents"
			[startIcon]="ICON.DOLLAR"
			[(ngModel)]="price"
			[submitted]="submitted"
			[required]="true"
			name="price"
			class="flex-1 w-full mt-4 mb-5"
		></app-input>
	</app-container>
	<div class="flex-1 flex justify-between w-full">
		<app-button btn="secondary" mat-dialog-close size="small"
			>Cancel</app-button
		>
		<app-button type="submit" size="small">Add</app-button>
	</div>
</form>
